import { createAction } from '@reduxjs/toolkit';
import type { IErrorType } from '../../constants/types';
import type { IUserSummary } from '../../types/global/helper';
import type {
    IAdminAdvancedSearchFilterOptions,
    IAdminAdvancedSearchResult,
    IAdminUserAdvancedSearchPayload,
} from '../../types/global/adminUserAdvancedSearch.types';
import { types } from './types';

export const adminSearchUsers = createAction<string>(types.ADMIN_SEARCH_USERS);
export const adminSearchUsersSuccess = createAction<IUserSummary[]>(types.ADMIN_SEARCH_USERS_SUCCESS);
export const adminSearchUsersFail = createAction<IErrorType>(types.ADMIN_SEARCH_USERS_FAIL);

export type IFetchAdminAdvancedSearchFilterOptionsPayload = {
    facet?: string;
    search?: string;
    searchTerm?: string;
    page?: number;
    limit?: number;
};

export const fetchAdminAdvancedSearchFilterOptions = createAction<
    IFetchAdminAdvancedSearchFilterOptionsPayload | undefined
>(types.FETCH_ADVANCED_SEARCH_FILTER_OPTIONS);
export const fetchAdminAdvancedSearchFilterOptionsSuccess = createAction<IAdminAdvancedSearchFilterOptions>(
    types.FETCH_ADVANCED_SEARCH_FILTER_OPTIONS_SUCCESS,
);
export const fetchAdminAdvancedSearchFilterOptionsFail = createAction<IErrorType>(
    types.FETCH_ADVANCED_SEARCH_FILTER_OPTIONS_FAIL,
);

export const postAdminAdvancedSearch = createAction<IAdminUserAdvancedSearchPayload>(types.POST_ADMIN_ADVANCED_SEARCH);
export const postAdminAdvancedSearchSuccess = createAction<IAdminAdvancedSearchResult>(
    types.POST_ADMIN_ADVANCED_SEARCH_SUCCESS,
);
export const postAdminAdvancedSearchFail = createAction<IErrorType>(types.POST_ADMIN_ADVANCED_SEARCH_FAIL);
